var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnveloppeoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 9.79922C0.87 9.79922 0.5875 9.68172 0.3525 9.44672C0.1175 9.21172 0 8.92922 0 8.59922V1.39922C0 1.06922 0.1175 0.786719 0.3525 0.551719C0.5875 0.316719 0.87 0.199219 1.2 0.199219H10.8C11.13 0.199219 11.4125 0.316719 11.6475 0.551719C11.8825 0.786719 12 1.06922 12 1.39922V8.59922C12 8.92922 11.8825 9.21172 11.6475 9.44672C11.4125 9.68172 11.13 9.79922 10.8 9.79922H1.2ZM6 5.59922L1.2 2.59922V8.59922H10.8V2.59922L6 5.59922ZM6 4.39922L10.8 1.39922H1.2L6 4.39922ZM1.2 2.59922V1.39922V8.59922V2.59922Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnveloppeoutline);
export default __webpack_public_path__ + "static/media/enveloppeoutline.ab8684595f59048e1b59bcc57bf0b078.svg";
export { ForwardRef as ReactComponent };